import PaginationLayout from "../components/PaginationLayout";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { Link, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import Swal from "sweetalert2";
import { getUserProfileImage } from "../utils/constant_value";

export default () => {
  const location = useLocation();
  let limit = 10;
  const { authState ,handleError,handlePagination, handleFilter } = useContext(GlobalContext);
  const param = useParams();
  const newParam = new URLSearchParams(location.search);
  var query = new URLSearchParams(location.search);
  const [pageData, setPageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [searchData, setSearchData] = useState("");
  henceforthApi.setToken(authState.access_token);

  const init = async () => {
    setLoading(true);
    let searchData = newParam.has("search") ? newParam.get("search") : null;
    setSearchData(searchData);
    try {
      let q = query.toString();
      let apiRes = await henceforthApi.User.getListing(
        searchData,
        q,
        Number(param.page) - 1,
        limit
      );
      setPageData(apiRes.users);
      setTotalCount(apiRes.count);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error)
      setPageData([]);
    }
  };
  const [manageUsers, setManageUsers] = useState({
    type: "",
    _id: "",
    admin_verified: false,
    language: "ENGLISH",
    account_status: "",
  });
  const handleActivate = async (res) => {
    let data = {
      _id: res?._id,
      language: "ENGLISH",
      account_status:
        res?.account_status == "Activated" ? `Deactivated` : `Activated`,
    };
    try {
      const manage_users = await henceforthApi.User.manageUsers(data);
      setManageUsers(data);
      {
        res?.account_status == "Deactivated"
          ? Swal.fire({
            title: "Activated",
            text: "Account Activated Successfully",
            icon: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "black"
          })
          : Swal.fire({
            title: "Deactivated",
            text: "Account Deactivated Successfully",
            icon: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "black"
          });
      }
    } catch (error) {
      handleError(error)
    }
  };

  //Filter
  const filters = [
    { name: "Active", value: "Active" },
    { name: "De-Active", value: "De-Active" },
  ];
  
  useEffect(() => {
    init();
  }, [param.page, query.get("filter"), newParam.get("search"), manageUsers]);

  return (
    <>
      <div className="ibox animated fadeInRight">
        <div
          className="ibox-title d-flex align-items-center justify-content-between"
          style={{ color: "#000000" }}
        >
          <h5 style={{ fontSize: "16px" }} className="m-0 fw-bold">
            List of all Users
          </h5>
          <div className="dropdown theme me-3">
            <button
              className="btn dashboard-button pe-4 ps-4 dropdown-toggle shadow-none"
              id="sortDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {filters.filter((res) => res.value == query.get("filter")).length
                ? filters.filter((res) => res.value === query.get("filter"))[0]
                  .name
                : "All"}
            </button>
            <ul
              className="dropdown-menu share-icons"
              aria-labelledby="sortDropdown"
            >
              {query.has("filter") && (
                <li className="cursor-pointer">
                  <a
                    className="dropdown-item"
                    onClick={() => handleFilter("filter", "")}
                  >
                    All
                  </a>
                </li>
              )}
              {filters.map((res) => {
                return (
                  <li key={res.value} className="cursor-pointer">
                    <a
                      className="dropdown-item"
                      onClick={() => handleFilter("filter", res.value)}
                    >
                      {res.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="ibox-content">
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div class="input-group form-group">
              <input
                value={searchData || ""}
                name="searchInput"
                onChange={(e) => {
                  handleFilter("search",e.target.value)
                }}
                placeholder="Search by Name, User Name & Email"
                type="text"
                className="form-control form-control-sm "
                style={{ paddingBlock: "16px" }}
              />{" "}
              <span class="input-group-append">

              </span>
            </div>
          </form>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr style={{ color: "#000000", fontSize: "14px" }}>
                  <th>Sr. No.</th>
                  <th>Profile</th>
                  <th>Name</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Status </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {!loading && !pageData?.length ? <tr><td colSpan={8} className="text-center"> <b>No Users Found </b> </td></tr>  : pageData.map((res, index) => (
                  <tr style={{ fontSize: "14px" }} key={res._id}>
                    <td>
                      {param.page === "0"
                        ? index + 1
                        : (param.page - 1) * limit + (index + 1)}
                      .
                    </td>
                    <td className="justify-content-center">
                      <img
                        src={getUserProfileImage(res?.profile_pic , "small")}
                        className="me-2 imageSize"
                        alt="Profile"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = profile_placeholder;
                        }}
                      />
                    </td>
                    <td>
                      {/* <img src={res.profile_pic ? `${henceforthApi.API_FILE_ROOT_SMALL}${res.profile_pic}` : profile_placeholder} className="me-2 imageSize" alt="" /> */}
                      {res.full_name ? res.full_name : "Not available"}
                    </td>
                    <td>{res.username !=null ? res.username : "Not available"}</td>
                    <td>{res?.email != "" ? res?.email : "Not available"}</td>
                    <td className={res?.phone_no ? "" : "ml-[20vw]"}>
                          {res?.phone_no 
                            ? `+${res?.country_code || ""} ${res?.phone_no}` 
                            : "-- --"}
                    </td>

                    <td className="ActiveDeactive">
                      <i
                        onClick={() => handleActivate(res)}
                        className={
                          res.account_status == "Activated"
                            ? `fas fa-user-alt`
                            : `fas fa-user-alt-slash`
                        }
                        title={
                          res.account_status == "Activated"
                            ? "Active"
                            : "Deactivated"
                        }
                        style={{ width: "36px" }}
                        aria-hidden="true"
                      ></i>
                    </td>
                    <td>
                      <div className="d-flex">
                        <Link
                          style={{ fontSize: "14px" }}
                          to={`/user/${res?._id}/1/1?type=posts`}
                          className="btn btn-xs btn-white me-2"
                        >
                          <i className="fas fa-eye me-1"></i>
                          View
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <PaginationLayout
            count={totalCount}
            data={pageData}
            page={Number(param.page)}
            limit={Number(limit)}
            loading={loading}
            onPageChange={(val) => handlePagination(val)}
          />
        </div>
      </div>
    </>
  );
};
